import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'checklisSubfamilia',
})
export class tareasChecklistSubfamPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter['incidencias']) {

        items = items.filter((item) => {

          return (item.campos.filter((campo) => campo.observaciones)).length > 0;
        });
      }


      if (filter['search']) {

        items = items.filter((item) => {

          return (item.campos.filter((campo) => campo.label.toLowerCase().includes((filter['search']).toLowerCase()))).length > 0;
        });
      }

      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tareas-checklist/tareas-checklist-subfam.ts